<template>
  <div :class="['layout', { 'layout--bg-yellow-blue': this.$route.meta.backgroundColor === 'yellow-blue' }]">
    <main class="container-fluid">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'FullPage',
};
</script>

<style lang="sass" scoped>
.layout
  min-height: 100vh
  +modifier('bg-yellow-blue')
    position: relative
    background-size: cover
    background-position: 50% 50%
    background-repeat: no-repeat
    background-image: url('~@/assets/fondo.svg')

  //  &:after
  //    content: ''
  //    position: absolute
  //    width: 50%
  //    left: 0
  //    bottom: 0
  //    height: 50%
  //    background: #cdd41e
  //    z-index: -1
  //  &:before
  //    content: ''
  //    position: absolute
  //    width: 50%
  //    left: 50%
  //    height: 50%
  //    background: #1f5272
  //    z-index: -1

.page-container
  transition: all .2s ease
  // overflow: hidden
  // min-height: inherit
  // +forTablet
  //   padding-left: 250px
  //   +modifier('margin-left-100')
  //     padding-left: 100px
</style>
